import { NgModule } from '@angular/core';
import { InjectionToken } from '@angular/core';

// TODO: use typed Window
export const WINDOW = new InjectionToken<any>('WindowToken');

export function _window(): any {
  return typeof window !== 'undefined' && window ? window : {};
}

@NgModule({
  providers: [{
    provide: WINDOW,
    useFactory: _window
  }]
})
export class WindowTokenModule { }



// WEBPACK FOOTER //
// ./src/modules/window-token/window-token.module.ts